import { createMaybeSelector } from '@ally/data-selectors';
export var getDomainData = function (_a) {
    var _b;
    var restrictedDates = _a.restrictedDates;
    return (_b = restrictedDates === null || restrictedDates === void 0 ? void 0 : restrictedDates.data) !== null && _b !== void 0 ? _b : null;
};
export var getAllRestrictedDates = createMaybeSelector(getDomainData, function (data) { return data.RestrictedDates; });
//# sourceMappingURL=selectors.js.map